import BrandName from "@/components/site/BrandName";

// Optional monogram initials badge for team members etc. (no chibi avatars)
function Monogram({ initials = "CC", tone = "#D4A65A", size = 40 }) {
  return (
    <span
      className="relative inline-flex items-center justify-center rounded-full border"
      style={{
        width: size,
        height: size,
        background: "linear-gradient(180deg, #0F1A2E 0%, #050B18 100%)",
        borderColor: `${tone}30`,
      }}
      aria-hidden="true"
    >
      <span
        className="font-display font-semibold tracking-tight"
        style={{ color: tone, fontSize: size * 0.38, letterSpacing: "0.02em" }}
      >
        {initials}
      </span>
    </span>
  );
}

export { Monogram };

export default function Brand({ className = "", tone = "light" }) {
  const ink = tone === "light" ? "#F5F1E8" : "#0B1220";
  const accent = "#D4A65A";
  return (
    <a
      href="/"
      className={`inline-flex items-center gap-3 ${className}`}
      data-testid="brand-logo"
    >
      <span className="relative inline-flex h-9 w-9 items-center justify-center">
        <svg
          viewBox="0 0 44 44"
          className="h-9 w-9"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <defs>
            <linearGradient id="sealBg" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#0F1A2E" />
              <stop offset="100%" stopColor="#050B18" />
            </linearGradient>
            <linearGradient id="sealStroke" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor={accent} stopOpacity="0.9" />
              <stop offset="100%" stopColor={accent} stopOpacity="0.3" />
            </linearGradient>
          </defs>
          <path
            d="M13 3 h18 l10 10 v18 l-10 10 h-18 l-10 -10 v-18 z"
            fill="url(#sealBg)"
            stroke="url(#sealStroke)"
            strokeWidth="0.8"
          />
          <circle
            cx="22"
            cy="22"
            r="12"
            fill="none"
            stroke={accent}
            strokeOpacity="0.35"
            strokeWidth="0.6"
          />
          <path
            d="M28.5 16.5c-1.5-1.6-3.5-2.5-6-2.5-4.5 0-7.8 3.4-7.8 8s3.3 8 7.8 8c2.5 0 4.5-.9 6-2.5"
            fill="none"
            stroke={accent}
            strokeWidth="1.9"
            strokeLinecap="square"
          />
          <circle cx="30" cy="22" r="1.2" fill={accent} />
        </svg>
      </span>
      <BrandName
        className="font-display text-[16px] font-semibold tracking-[-0.01em]"
        tone={ink}
      />
    </a>
  );
}
